import {
    findMenuSliceWithPageId, 
    replaceBackEndUrl,
    replaceBackEndUrlFromMenu
} from './api_tools'

import NewsArticle from './classes/NewsArticle'
import Artist from './classes/Artist'
import ContentPage from './classes/ContentPage'

const BACKEND_URL = "https://content.porijazz.fi";
const NEWS_CATEGORY_FI = 1;
const NEWS_CATEGORY_EN = 8;
const API_AUTH = "d2ViYXBwOmVvQmxPNlU4MkN1MmhZN1JEdllRTnRyUA=="

const TESTIMONIALS_CATEGORY_FI=65
const TESTIMONIALS_CATEGORY_EN=93

export async function REST_getNodeBySlugAndLang(slug, lang, raw = false){
    let content;

    content = await REST_getPageWithSlugAndLang(slug, lang, raw);
    if(content){
        return content;
    }

    content = await REST_getPostWithSlugAndLang(slug, lang);
    if(content){
        return content;
    }

    //console.log("error 5000");

    return undefined;
}

export async function REST_getPostWithSlugAndLang(slug, lang){
    const response = await fetch(BACKEND_URL+'/wp-json/wp/v2/posts?slug='+slug+'&lang='+lang, {
        headers: {
            //'Authorization': 'Basic '+API_AUTH
        }
    });
    const post = await response.json();

    return post[0];
}

export async function REST_getPageWithSlugAndLang(slug, lang, raw = false){
    const response = await fetch(BACKEND_URL+'/wp-json/wp/v2/pages?acf_format=standard&slug='+slug+'&lang='+lang, {
        headers: {
            //'Authorization': 'Basic '+API_AUTH
        }
    });
    const pagedata = await response.json();

    if(raw){
        return pagedata[0];
    }

    let page = new ContentPage;

    page.fromRestData(pagedata[0]);

    return page;
}

export async function REST_getAllUris(pagesOnly = false){
    let allPages = await pagedQuery(BACKEND_URL+'/wp-json/wp/v2/pages?per_page=100');

    let uris = [];


    for(let i = 0; i < allPages.length; i++){
        if(allPages[i].link){

            let uri = replaceBackEndUrl(allPages[i].link).substring(1);
            uri = uri.substring(0, uri.length - 1);

            if(uri === "/undefined/"){
                continue;
            }

            let uriData = {params: {
                uri: uri
            }};
            uris.push(uriData);
        }
    }

    if(pagesOnly){
        return uris;
    }

    let allPosts = await pagedQuery(BACKEND_URL+'/wp-json/wp/v2/posts?per_page=100');

    for(let i = 0; i < allPosts.length; i++){
        if(allPosts[i].link){
            let uri = replaceBackEndUrl(allPosts[i].link).substring(1);
            uri = uri.substring(0, uri.length - 1)

            let uriData = {params: {
                uri: uri
            }};
            uris.push(uriData);
        }
    }

    return uris;
}

export async function REST_getMenuWithSlug(slug, convertUrls = true){
    const response = await fetch(BACKEND_URL+'/wp-json/menus/v1/menus/'+slug, {
    headers: {
        //'Authorization': 'Basic '+API_AUTH
    }
    });
    const data = await response.json();
    
    if(!convertUrls){
        return data;
    }

    let modified_menu = replaceBackEndUrlFromMenu(data);

    return modified_menu;
}

export async function getSubMenuForPageWithPageIdAndMenuName(pageId, menuName){
    const menu = await REST_getMenuWithSlug(menuName);
        
    let menuslice = findMenuSliceWithPageId(pageId, menu);

    return menuslice;
}

export async function REST_getMediaWithId(id){
    let mediaQuery = '/wp-json/wp/v2/media/'+id;
    const response = await fetch(BACKEND_URL+mediaQuery, {
        headers: {
          //'Authorization': 'Basic '+API_AUTH
        }
    });

    const data = await response.json();
    return data;
}

export async function REST_getMultipleMediaWithIDs(IDs){
    let mediaQuery = '/wp-json/wp/v2/media?per_page=100&include='+IDs;

    let mediaData = await pagedQuery(BACKEND_URL+mediaQuery);

    return mediaData;
}

export async function REST_getAllNews(){
    let catId = NEWS_CATEGORY_FI+","+NEWS_CATEGORY_EN;
    let newsQuery = '/wp-json/wp/v2/posts?per_page=100&categories='+catId;

    let allNews = await pagedQuery(BACKEND_URL+newsQuery);



    return allNews;
}

export async function REST_getAllTestimonials(){
    let catId = TESTIMONIALS_CATEGORY_FI+","+TESTIMONIALS_CATEGORY_EN;
    let testimonialsQuery = '/wp-json/wp/v2/posts?per_page=100&categories='+catId;
    
    let allTestimonials = await pagedQuery(BACKEND_URL+testimonialsQuery);

    return allTestimonials;
}

export async function REST_getNewsByLang(lang, raw = false){
    let catId;

    if(lang == "fi"){
        catId = NEWS_CATEGORY_FI;
    }else{
        catId = NEWS_CATEGORY_EN;
    }
    
    let newsQuery = '/wp-json/wp/v2/posts?acf_format=standard&per_page=100&categories='+catId;

    let data = await pagedQuery(BACKEND_URL+newsQuery);

    if(raw){
        return data;
    }
    
    let articles = [];

    //remove hardcoded wordpress url from link
    for(let i = 0; i < data.length; i++){        
        let article = new NewsArticle;
        article.fromRestData(data[i]);
        articles.push(article);
    }
    
    return articles;
}

export async function REST_getTestimonialsByLang(lang, raw = false){
    let catId;

    if(lang == "fi"){
        catId = TESTIMONIALS_CATEGORY_FI;
    }else{
        catId = TESTIMONIALS_CATEGORY_EN;
    }
    
    let newsQuery = '/wp-json/wp/v2/posts?acf_format=standard&per_page=100&categories='+catId;

    let data = await pagedQuery(BACKEND_URL+newsQuery);

    if(raw){
        return data;
    }
    
    let articles = [];

    //remove hardcoded wordpress url from link
    for(let i = 0; i < data.length; i++){        
        let article = new NewsArticle;
        article.fromRestData(data[i]);
        articles.push(article);
    }
    
    return articles;
}

export async function REST_getNewsArticleWithSlugAndLang(slug, lang){
    const response = await fetch(BACKEND_URL+'/wp-json/wp/v2/posts?acf_format=standard&slug='+slug+'&lang='+lang, {
        headers: {
            //'Authorization': 'Basic '+API_AUTH
        }
    });
    const post = await response.json();

    let article = buildArticleObject(post[0]);
    
    return article;
}

export async function REST_getTestimonialWithSlugAndLang(slug, lang){
    const response = await fetch(BACKEND_URL+'/wp-json/wp/v2/posts?acf_format=standard&slug='+slug+'&lang='+lang, {
        headers: {
            //'Authorization': 'Basic '+API_AUTH
        }
    });
    const post = await response.json();

    let article = buildArticleObject(post[0]);
    
    return article;
}

export async function buildArticleObject(raw_data){
    //remove hardcoded wordpress url from link
    let article = new NewsArticle;

    article.fromRestData(raw_data);
    return article;
}

export async function REST_getArtists(raw = false){
    const artistsData = await pagedQuery(BACKEND_URL+'/wp-json/wp/v2/artists?acf_format=standard&per_page=100');

    if(raw){
        return artistsData;
    }

    let artists = [];

    for(let i = 0; i < artistsData.length; i++){        
        let artist = new Artist;

        artist.fromRestData(artistsData[i]);
        artists.push(artist);
    }

    return artists;
}

export async function REST_getArtistWithSlug(slug, raw = false){
    const response = await fetch(BACKEND_URL+'/wp-json/wp/v2/artists?acf_format=standard&slug='+slug, {
    headers: {
        //'Authorization': 'Basic '+API_AUTH
    }
    });
    const data = await response.json();

    if(raw){
        return data[0];
    }

    let artist = new Artist;

    artist.fromRestData(data[0]);

    return artist;
}

export async function REST_getNotificationBanners(){
    const response = await fetch(BACKEND_URL+'/wp-json/wp/v2/notificationBanners', {
        headers: {
            //'Authorization': 'Basic '+API_AUTH
        }
    });
    const banners = await response.json();

    return banners;
}

async function pagedQuery(url){
    let items = [];
    let paging = 1;
    let pagesRemaining = true;

    do{
        const res = await fetch(url+'&page='+paging, {
            headers: {
            //'Authorization': 'Basic '+API_AUTH,
            }
        });

        const data = await res.json();

        if(res.status == 200){
            if(data.length > 0){
                items.push(...data);
            }else{
                pagesRemaining = false;
                break;
            }
        }else{
            pagesRemaining = false;
            //console.log("not anymore pagings left!!!! (page number reached: "+paging+")");
            break;
        }




        paging++;

        //failsafe
        if(paging > 100){
            break;
        }
    }while(pagesRemaining == true);
    return items;
}